import { useMediaQuery } from '@chakra-ui/react';

export default function useDeviceSize() {
  const isDesktopOrLaptop = useMediaQuery('(min-width: 1224px)')[0];
  const isMobile = useMediaQuery('(max-width: 425px)')[0];

  return { isDesktopOrLaptop, isMobile };
}
